import type { UploadItem } from '@shared/lib/uploads';
import { getVideoMediafileUploadTag } from './consts';

type UploadView = Pick<UploadItem, 'id' | 'requestId' | 'fileName' | 'status'>;

export const selectVideoMediafileUploads = (state: RootState, companyId: string): UploadView[] =>
  Object.values(state.uploads.items)
    .filter((item) => item.tag === getVideoMediafileUploadTag(companyId))
    .map(({ id, requestId, fileName, status }) => ({ id, requestId, fileName, status }));

// The library displays lifecycle states, not byte progress. Avoid rerendering its loaded rows on every XHR event.
export const areVideoMediafileUploadsEqual = (previous: UploadView[], next: UploadView[]) =>
  previous.length === next.length &&
  previous.every(
    (item, index) =>
      item.id === next[index].id &&
      item.requestId === next[index].requestId &&
      item.fileName === next[index].fileName &&
      item.status === next[index].status
  );
